import DatePickerPopover, { Props as DatePickerPopoverProps } from './DatePickerPopover';
import TimePicker from './TimePicker';
import { formatToTimeZone, getTimeInTimezone, IsoTimestamp } from '#datetime';
import { DateIcon } from '#icons';
import { Button, Stack } from '@mui/material';
import { toZonedTime } from 'date-fns-tz';
import { useRef, useState } from 'react';

type Props = {
  time: IsoTimestamp;
  timezone: string;
  onChange: (utcTime: IsoTimestamp) => void;
} & Pick<DatePickerPopoverProps, 'renderDay' | 'disableFuture' | 'disablePast'>;

const DateTimePicker = ({ time, timezone, disableFuture, disablePast, onChange, renderDay }: Props) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const datePickerRef = useRef<HTMLButtonElement>(null);

  const openDatePicker = () => {
    setDatePickerOpen(true);
  };

  const handleDatePickerClose = () => {
    setDatePickerOpen(false);
  };

  const handleDateChange = (date: IsoTimestamp) => {
    const prevTime = toZonedTime(time, timezone);
    const newTime = getTimeInTimezone(date, timezone, prevTime.getHours(), prevTime.getMinutes());
    onChange(newTime);
    handleDatePickerClose();
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button
        onClick={openDatePicker}
        ref={datePickerRef}
        startIcon={<DateIcon />}
        // eslint-disable-next-line no-restricted-syntax
        sx={{ borderRadius: '6px', width: '150px', justifyContent: 'flex-start', flexShrink: 0 }}
      >
        {formatToTimeZone(time, 'MMM d yyy', timezone)}
      </Button>

      <DatePickerPopover
        open={datePickerOpen}
        date={time}
        timezone={timezone}
        disableFuture={disableFuture}
        disablePast={disablePast}
        anchorEl={datePickerRef.current}
        onClose={handleDatePickerClose}
        renderDay={renderDay}
        onChange={handleDateChange}
      />

      <TimePicker time={time} timezone={timezone} onChange={onChange} />
    </Stack>
  );
};

export default DateTimePicker;
